import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

export const fadeInOnly = trigger('fadeInOnly', [
  state('in', style({ transform: 'translateX(0)' })),
  transition(':enter', [animate(250, keyframes([style({ opacity: 0 }), style({ opacity: 1 })]))]),
]);
